import PageLayout from '@/components/page/page-layout'

const User = () => import('@/views/user')

const router = {
  path: '/user',
  component: PageLayout,
  redirect: '/user/account',
  name: 'User',
  icon: 'none',
  children: [
    {
      path: 'account',
      name: 'Account',
      component: User,
      meta: {
        currentMenu: 'device',
        hideBreadcrumb: true,
        title: '个人信息'
      }
    }
  ]
}

export default router
